export default __webpack_public_path__ + "static/media/Size4D.25455556.png";